const knobDiameter = 64;
const planSectionMinimalWidth = 50;
const planSectionHeight = 48;
const planContainerWidth = 30;
const planContainerHeight = 30;
const trackPaddingSize = 32;

export { knobDiameter, planContainerHeight, planContainerWidth, planSectionHeight, planSectionMinimalWidth, trackPaddingSize };
